import React from 'react';
import styled from '@emotion/styled';
import Fa from 'components/fa';

const Warning = styled(Fa)`
  color: #ff5252;
  font-size: 18px;
`;

const FaWarning = props => (
  <Warning
    {...props}
    i='warning'
  />
);

export default FaWarning;
